<template>
	<div>
		<tariff-edit-modal
			v-if="showTariffEdit"
			:tariff-entry="selectedTariffEntry"
			:zone-names="zoneNames"
			@close="showTariffEdit = false"
			@save="onSaveTariffEntry"
		/>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/tariffs"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="
									!editTariff.name ||
									loading ||
									saving ||
									($global.hasUserRole(userRoles, 'admin') &&
										!editTariff.reseller &&
										!editTariff.tenant) ||
									(!$global.hasUserRole(userRoles, 'admin') &&
										$global.hasUserRole(userRoles, 'tenant') &&
										!editTariff.tenant)
								"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ saving ? 'Saving...' : editTariff.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/tariffs')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"></div>
					</div>
					<div class="row margin-b20">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto mb-5 w-full">
									<div class="col-sm-12 textCenter">
										<div class="navAvatar margin-b10 flex w-full justify-center">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div class="mx-auto mb-2 flex w-full flex-col md:mb-5 md:flex-row">
										<div class="flex w-full gap-2 px-2">
											<div class="formGroup w-[calc(100%-0.5rem)] lg:w-[calc(50%-0.5rem)]">
												<label class="textGrey">Name</label>
												<FormKit
													v-model="editTariff.name"
													type="text"
													class="form-control"
													placeholder="Tariff Name"
													name="Name"
													:validation="'required'"
													validation-visibility="live"
												/>
											</div>
										</div>
									</div>
									<div class="flex w-full gap-2 px-2">
										<div
											v-if="!editTariff.id && $global.hasUserRole(userRoles, 'admin')"
											class="mb-2 w-[calc(100%-0.5rem)] md:mb-5 lg:w-[calc(50%-0.5rem)]"
										>
											<div class="formGroup withIcon">
												<label class="textGrey">Reseller</label>
												<select v-model="editTariff.reseller" required>
													<option :value="null">-- Select Reseller --</option>
													<option v-for="r in resellers" :key="r.id" :value="r">
														{{ r.companyName }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
										<div
											v-if="
												!editTariff.id &&
												!editTariff.reseller &&
												(tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller'))
											"
											class="mb-2 w-[calc(100%-0.5rem)] md:mb-5 lg:w-[calc(50%-0.5rem)]"
										>
											<div class="formGroup withIcon">
												<label class="textGrey">Tenant</label>
												<select v-model="editTariff.tenant" required>
													<option :value="null">
														{{
															$global.hasUserRole(userRoles, 'reseller')
																? 'Reseller Only'
																: '-- Select Tenant --'
														}}
													</option>
													<option v-for="t in tenants" :key="t.id" :value="t">
														{{ t.companyName }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="flex w-full justify-start px-2">
										<div class="formGroup w-[calc(100%-0.5rem)] lg:w-[calc(50%-0.5rem)]">
											<label class="textGray">Search</label>
											<FormKit
												id="search_box"
												v-model="searchField"
												type="text"
												placeholder="Search"
											/>
										</div>
									</div>
									<div class="row hideTablet mx-auto mt-6 w-full px-2">
										<div class="w-full">
											<div class="text-xs font-black uppercase text-gray-400">
												<div class="flex w-full">
													<div class="basis-[20%] xl:basis-2/12">
														<p>Zone Name</p>
													</div>
													<div class="basis-[15%] xl:basis-1/12">
														<p>Time Class</p>
													</div>
													<div class="basis-[13%] xl:basis-1/12">
														<p>Min Charge</p>
													</div>
													<div class="basis-[13%] xl:basis-1/12">
														<p>Initial Charge</p>
													</div>
													<div class="basis-[13%] xl:basis-1/12">
														<p>First Charge</p>
													</div>
													<div class="basis-1/12 md:hidden xl:block">
														<p>First Time</p>
													</div>
													<div class="basis-[13%] xl:basis-1/12">
														<p>Sub Charge</p>
													</div>
													<div class="basis-1/12 md:hidden xl:block">
														<p>Sub Time</p>
													</div>
													<div class="basis-1/12 md:hidden xl:block">
														<p>MAL</p>
													</div>
													<div class="basis-1/12 md:hidden xl:block">
														<p>PAL</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										v-if="filteredTariffs.length > 10"
										class="relative flex w-full items-center py-3"
									>
										<div class="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
										<button
											class="flex-shrink rounded-sm border border-gray-200 px-4 py-1.5 text-gray-600 hover:bg-gray-200 dark:border-gray-500 dark:text-gray-200 dark:hover:bg-gray-500"
											@click="createTariffEntry"
										>
											<span class="fa-light fa-plus"></span>
											Add New
										</button>
										<div class="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
									</div>
									<div
										class="row mx-auto mb-5 w-full px-2"
										:class="{ 'mt-5': filteredTariffs.length <= 10 }"
									>
										<div class="w-full">
											<div
												v-for="(tariffEntry, i) in filteredTariffs"
												:key="i"
												class="mb-8 grid w-full grid-cols-2 md:mb-2 md:flex md:flex-row"
											>
												<div class="w-full basis-[20%] xl:basis-2/12">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														Zone name:
													</p>
													<div class="formGroup">
														<p
															class="font-bold"
															:class="{
																'text-red': !isCurrentZoneName(tariffEntry.zone_name)
															}"
														>
															{{ tariffEntry.zone_name }}
														</p>
													</div>
												</div>
												<div class="basis-[15%] xl:basis-1/12">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														Time class:
													</p>
													<div class="formGroup">
														<p>{{ formatTimeClass(tariffEntry.time_class) }}</p>
													</div>
												</div>
												<div class="basis-[13%] xl:basis-1/12">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														Min charge:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.min_chg }}</p>
													</div>
												</div>
												<div class="basis-[13%] xl:basis-1/12">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														Initial charge:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.init_chg }}</p>
													</div>
												</div>
												<div class="basis-[13%] xl:basis-1/12">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														First charge:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.first_chg }}</p>
													</div>
												</div>
												<div class="basis-1/12 md:hidden xl:block">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														First time:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.first_time }}s</p>
													</div>
												</div>
												<div class="basis-[13%] xl:basis-1/12">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														Sub charge:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.sub_chg }}</p>
													</div>
												</div>
												<div class="basis-1/12 md:hidden xl:block">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														Sub time:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.sub_time }}s</p>
													</div>
												</div>
												<div class="basis-1/12 md:hidden xl:block">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														MAL:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.mal }}</p>
													</div>
												</div>
												<div class="basis-1/12 md:hidden xl:block">
													<p
														class="text-[12px] font-semibold uppercase text-gray-500 md:hidden"
													>
														PAL:
													</p>
													<div class="formGroup">
														<p>{{ tariffEntry.pal }}</p>
													</div>
												</div>
												<div class="flex basis-[7%] gap-2 xl:basis-1/12">
													<button
														class="fab fabSm blue h-7 w-7"
														@click="editTariffEntry(tariffEntry.id)"
													>
														<span class="fa-light fa-pencil"></span>
													</button>
													<button
														v-if="tariffEntries.length > 1"
														class="fab fabSm red h-7 w-7"
														@click="removeZone(tariffEntry.id)"
													>
														<span class="fa-light fa-minus"></span>
													</button>
												</div>
											</div>
										</div>
										<div class="relative flex w-full items-center py-5">
											<div class="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
											<button
												class="flex-shrink rounded-sm border border-gray-200 px-4 py-1.5 text-gray-600 hover:bg-gray-200 dark:border-gray-500 dark:text-gray-200 dark:hover:bg-gray-500"
												@click="createTariffEntry"
											>
												<span class="fa-light fa-plus"></span>
												Add New
											</button>
											<div class="flex-grow border-t border-gray-200 dark:border-gray-500"></div>
										</div>
										<!-- <div class="col-xs-12 margin-t10 margin-b20">
                            <button class="fab fabSm green" @click="createTariffEntry"><span class="fa-light fa-plus"></span></button>
                        </div> -->
									</div>
									<div class="margin-b20 flex px-2">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="
															!editTariff.name ||
															($global.hasUserRole(userRoles, 'admin') &&
																!editTariff.reseller &&
																!editTariff.tenant) ||
															(!$global.hasUserRole(userRoles, 'admin') &&
																$global.hasUserRole(userRoles, 'tenant') &&
																!editTariff.tenant) ||
															saving ||
															loading
														"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ saving ? 'Saving...' : editTariff.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/tariffs')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import tariffsApi from '../scripts/tariffs/tariffs.api.js'
import resellersApi from '../scripts/resellers/resellers.api.js'
import tariffCodesApi from '../scripts/tariffcodes/tariffcodes.api.js'
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editTariff: {
				name: '',
				tenant: null,
				reseller: null
			},
			resellers: [],
			tariffEntries: [],
			zoneNames: [],
			showTariffEdit: false,
			loading: true,
			onSaveTariffEntry: null,
			searchField: '',
			saving: false,
			selectedTariffEntry: null
		}
	},

	computed: {
		filteredTariffs() {
			return this.tariffEntries
				.filter((te) => {
					return (
						te.zone_name.toLowerCase().includes(this.searchField.toLowerCase()) ||
						te.time_class.toLowerCase().includes(this.searchField.toLowerCase())
					)
				})
				.sort((a, b) => a.zone_name.localeCompare(b.zone_name))
		}
	},

	async created() {
		try {
			const tariffCodesResult = tariffCodesApi.getAllZoneNames()

			if (this.$global.hasUserRole(this.userRoles, 'admin'))
				resellersApi.getAll().then((result) => {
					this.resellers = result.data.results
				})

			if (this.$route.params.id !== 'new') {
				this.reload(this.$route.params.id)
			} else if (this.$global.hasUserRole(this.userRoles, 'tenant') && this.tenants?.length === 1)
				this.editTariff.tenant = this.tenants[0]

			this.zoneNames = (await tariffCodesResult).data.results
			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading tariff',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/tariffs')
			})
			console.error(e)
		}
	},

	methods: {
		isCurrentZoneName(zone_name) {
			return this.zoneNames.includes(zone_name)
		},
		getEmptyTariffEntry() {
			return {
				id: `new-${Date.now()}`,
				zone_name: null,
				time_class: 'ANY_DAY',
				min_chg: '0.0000',
				init_chg: '0.0000',
				first_chg: '0.0000',
				first_time: '0',
				sub_chg: '0.01',
				sub_time: '60',
				mal: '0.0000',
				pal: '0.0000'
			}
		},
		formatTimeClass(timeClass) {
			switch (timeClass) {
				case 'ANY_DAY':
					return 'Any Day'
				case 'PEAK':
					return 'Peak'
				case 'OFF_PEAK':
					return 'Off-Peak'
				case 'WEEKEND':
					return 'Weekend'
				default:
					return timeClass
			}
		},
		removeZone(id) {
			this.tariffEntries.splice(
				this.tariffEntries.findIndex((te) => te.id === id),
				1
			)
		},
		editTariffEntry(id) {
			const entry = this.tariffEntries.find((te) => te.id === id)
			if (entry) {
				this.selectedTariffEntry = { ...entry }
				this.onSaveTariffEntry = (te) => {
					const index = this.tariffEntries.findIndex((te) => te.id === id)
					if (index !== -1) {
						this.tariffEntries[index] = te
					}
					this.showTariffEdit = false
				}
				this.showTariffEdit = true
			}
		},
		createTariffEntry() {
			this.selectedTariffEntry = this.getEmptyTariffEntry()
			this.onSaveTariffEntry = (te) => {
				this.tariffEntries.push(te)
				this.showTariffEdit = false
			}
			this.showTariffEdit = true
		},
		reload(id) {
			this.loading = true
			tariffsApi
				.getById(id)
				.then((result) => {
					this.editTariff = result.data

					if (this.editTariff.tariffEntries && this.editTariff.tariffEntries.length)
						this.tariffEntries = this.editTariff.tariffEntries

					this.loading = false
				})
				.catch((err) => {
					this.loading = false
					console.error(err)
				})
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			this.saving = true
			this.editTariff.tariffEntries = this.tariffEntries.filter((te) => !!te.zone_name)

			if (!this.editTariff.id) {
				tariffsApi
					.create(this.editTariff)
					.then((u) => {
						this.saving = false
						this.routeTo('/tariffs')
					})
					.catch(console.error)
			} else {
				tariffsApi
					.update(this.editTariff)
					.then((u) => {
						this.saving = false
						this.routeTo('/tariffs')
					})
					.catch(console.error)
			}
		}
	}
}
</script>
